module.exports = __webpack_public_path__ + "static/media/logo_t.88899bb2.svg";